



























































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import {  UserStatsRequest } from '@/data/models/userstats.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { CrudService } from '@/data/services/crud.service';
import { Offer } from '@/data/models/offer.model';
import store, { State } from '@/store';

@Component
export default class StatCallsOperatore extends Vue {

	@Inject('CrudService') crudService!: CrudService<Offer>;

	@Prop() request!: UserStatsRequest;
	@Prop( { default: 20 }) page!: number;

	rows: Offer[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('offer join contact on contact.id = offer.contactid');

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	mounted() {
		this.reload();
	}

	reload() {
		this.advancedSearch.page.setPageNumber(0);
		this.advancedSearch.page.setSize(this.page);
		this.loadCalls();
	}

	loadCalls() {

		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('operatorid', this.request.oid!);
		this.advancedSearch.addNotEqualFilter('callid', null);
		this.advancedSearch.addRangeFilter('calldate', 
			Math.round(this.request.startdate!.getTime() / 1000), 
			Math.round(this.request.stopdate!.getTime() / 1000));

		const datareq = this.crudService.searchEntities(
			Offer,
			'offer',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Offer,
			'offer',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadCalls();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadCalls();
	}

}
